import axios from '@!/lib/axios'
import { getCsrfToken } from '@!/Util/postRequest'

export const getPurchaseHistoriesApi = async (nextToken = null) => {
  const params = { next_token: nextToken }
  return await axios.get('/api/v1/user/store/book_purchase_histories', {
    params,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const purchaseStoreWithFreeApi = async (purchaseParams) => {
  return await axios.post('/api/v1/purchase/store/free', purchaseParams, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}

export const purchaseStoreWithCoinApi = async (purchaseParams) => {
  return await axios.post('/api/v1/purchase/store/pay_with_coin', purchaseParams, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}

export const purchaseStoreWithCreditApi = async (purchaseParams) => {
  return await axios.post('/api/v1/purchase/store/pay_with_credit', purchaseParams, {
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  })
}
